import { Alert } from '@ps/sports-ui-component-library';
import { Site } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import { TXTWCL_Due_to_local_regulationsX_any__ELL } from './GermanOneHourRegulations.messages.json';
import styles from './GermanOneHourRegulations.scss';

const GermanOneHourRegulations = () => {
  const errorMessage = useSelector(select.betSlip.errorResponse);
  const site = useSelector(select.cms.getSiteId);
  const dispatch = useDispatch<Dispatch>();

  const dismissError = useCallback(() => {
    dispatch.betSlip.betLevelErrorDismissed();
  }, [dispatch.betSlip]);

  if (!errorMessage?.result) return null;

  const shouldDisplayAlert =
    Site.DE === site && errorMessage.result[0].resultCode === 'INSUFFICIENT_FUNDS';

  return shouldDisplayAlert ? (
    <Alert
      level="information"
      variant="passive-aggressive"
      className={styles.error}
      onDismiss={() => dismissError()}
      dismissLabel="dismiss error"
    >
      <Translation {...TXTWCL_Due_to_local_regulationsX_any__ELL} />
    </Alert>
  ) : null;
};

export default GermanOneHourRegulations;
